export default __webpack_public_path__ + "static/media/onnbikes.a1317e73.png";